var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1235 650",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 650,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 200,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 300,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 400,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 500,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 600,
    width: 1235,
    height: 50,
    fill: "#b31942"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 350,
    fill: "#0a3161"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.17,14.98 45.66,28.81 60.21,28.81 48.44,37.36 52.93,51.20 41.17,42.65 29.40,51.20 33.89,37.36 22.13,28.81 36.67,28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.50,14.98 127.99,28.81 142.54,28.81 130.77,37.36 135.27,51.20 123.50,42.65 111.73,51.20 116.23,37.36 104.46,28.81 119.01,28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.83,14.98 210.33,28.81 224.87,28.81 213.11,37.36 217.60,51.20 205.83,42.65 194.07,51.20 198.56,37.36 186.79,28.81 201.34,28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.17,14.98 292.66,28.81 307.21,28.81 295.44,37.36 299.93,51.20 288.17,42.65 276.40,51.20 280.89,37.36 269.13,28.81 283.67,28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.50,14.98 374.99,28.81 389.54,28.81 377.77,37.36 382.27,51.20 370.50,42.65 358.73,51.20 363.23,37.36 351.46,28.81 366.01,28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.83,14.98 457.33,28.81 471.87,28.81 460.11,37.36 464.60,51.20 452.83,42.65 441.07,51.20 445.56,37.36 433.79,28.81 448.34,28.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.33,49.98 86.83,63.81 101.37,63.81 89.61,72.36 94.10,86.20 82.33,77.65 70.57,86.20 75.06,72.36 63.29,63.81 77.84,63.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.67,49.98 169.16,63.81 183.71,63.81 171.94,72.36 176.43,86.20 164.67,77.65 152.90,86.20 157.39,72.36 145.63,63.81 160.17,63.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.00,49.98 251.49,63.81 266.04,63.81 254.27,72.36 258.77,86.20 247.00,77.65 235.23,86.20 239.73,72.36 227.96,63.81 242.51,63.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.33,49.98 333.83,63.81 348.37,63.81 336.61,72.36 341.10,86.20 329.33,77.65 317.57,86.20 322.06,72.36 310.29,63.81 324.84,63.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.67,49.98 416.16,63.81 430.71,63.81 418.94,72.36 423.43,86.20 411.67,77.65 399.90,86.20 404.39,72.36 392.63,63.81 407.17,63.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.17,84.98 45.66,98.81 60.21,98.81 48.44,107.36 52.93,121.20 41.17,112.65 29.40,121.20 33.89,107.36 22.13,98.81 36.67,98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.50,84.98 127.99,98.81 142.54,98.81 130.77,107.36 135.27,121.20 123.50,112.65 111.73,121.20 116.23,107.36 104.46,98.81 119.01,98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.83,84.98 210.33,98.81 224.87,98.81 213.11,107.36 217.60,121.20 205.83,112.65 194.07,121.20 198.56,107.36 186.79,98.81 201.34,98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.17,84.98 292.66,98.81 307.21,98.81 295.44,107.36 299.93,121.20 288.17,112.65 276.40,121.20 280.89,107.36 269.13,98.81 283.67,98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.50,84.98 374.99,98.81 389.54,98.81 377.77,107.36 382.27,121.20 370.50,112.65 358.73,121.20 363.23,107.36 351.46,98.81 366.01,98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.83,84.98 457.33,98.81 471.87,98.81 460.11,107.36 464.60,121.20 452.83,112.65 441.07,121.20 445.56,107.36 433.79,98.81 448.34,98.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.33,119.98 86.83,133.81 101.37,133.81 89.61,142.36 94.10,156.20 82.33,147.65 70.57,156.20 75.06,142.36 63.29,133.81 77.84,133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.67,119.98 169.16,133.81 183.71,133.81 171.94,142.36 176.43,156.20 164.67,147.65 152.90,156.20 157.39,142.36 145.63,133.81 160.17,133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.00,119.98 251.49,133.81 266.04,133.81 254.27,142.36 258.77,156.20 247.00,147.65 235.23,156.20 239.73,142.36 227.96,133.81 242.51,133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.33,119.98 333.83,133.81 348.37,133.81 336.61,142.36 341.10,156.20 329.33,147.65 317.57,156.20 322.06,142.36 310.29,133.81 324.84,133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.67,119.98 416.16,133.81 430.71,133.81 418.94,142.36 423.43,156.20 411.67,147.65 399.90,156.20 404.39,142.36 392.63,133.81 407.17,133.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.17,154.98 45.66,168.81 60.21,168.81 48.44,177.36 52.93,191.20 41.17,182.65 29.40,191.20 33.89,177.36 22.13,168.81 36.67,168.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.50,154.98 127.99,168.81 142.54,168.81 130.77,177.36 135.27,191.20 123.50,182.65 111.73,191.20 116.23,177.36 104.46,168.81 119.01,168.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.83,154.98 210.33,168.81 224.87,168.81 213.11,177.36 217.60,191.20 205.83,182.65 194.07,191.20 198.56,177.36 186.79,168.81 201.34,168.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.17,154.98 292.66,168.81 307.21,168.81 295.44,177.36 299.93,191.20 288.17,182.65 276.40,191.20 280.89,177.36 269.13,168.81 283.67,168.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.50,154.98 374.99,168.81 389.54,168.81 377.77,177.36 382.27,191.20 370.50,182.65 358.73,191.20 363.23,177.36 351.46,168.81 366.01,168.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.83,154.98 457.33,168.81 471.87,168.81 460.11,177.36 464.60,191.20 452.83,182.65 441.07,191.20 445.56,177.36 433.79,168.81 448.34,168.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.33,189.98 86.83,203.81 101.37,203.81 89.61,212.36 94.10,226.20 82.33,217.65 70.57,226.20 75.06,212.36 63.29,203.81 77.84,203.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.67,189.98 169.16,203.81 183.71,203.81 171.94,212.36 176.43,226.20 164.67,217.65 152.90,226.20 157.39,212.36 145.63,203.81 160.17,203.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.00,189.98 251.49,203.81 266.04,203.81 254.27,212.36 258.77,226.20 247.00,217.65 235.23,226.20 239.73,212.36 227.96,203.81 242.51,203.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.33,189.98 333.83,203.81 348.37,203.81 336.61,212.36 341.10,226.20 329.33,217.65 317.57,226.20 322.06,212.36 310.29,203.81 324.84,203.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.67,189.98 416.16,203.81 430.71,203.81 418.94,212.36 423.43,226.20 411.67,217.65 399.90,226.20 404.39,212.36 392.63,203.81 407.17,203.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.17,224.98 45.66,238.81 60.21,238.81 48.44,247.36 52.93,261.20 41.17,252.65 29.40,261.20 33.89,247.36 22.13,238.81 36.67,238.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.50,224.98 127.99,238.81 142.54,238.81 130.77,247.36 135.27,261.20 123.50,252.65 111.73,261.20 116.23,247.36 104.46,238.81 119.01,238.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.83,224.98 210.33,238.81 224.87,238.81 213.11,247.36 217.60,261.20 205.83,252.65 194.07,261.20 198.56,247.36 186.79,238.81 201.34,238.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.17,224.98 292.66,238.81 307.21,238.81 295.44,247.36 299.93,261.20 288.17,252.65 276.40,261.20 280.89,247.36 269.13,238.81 283.67,238.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.50,224.98 374.99,238.81 389.54,238.81 377.77,247.36 382.27,261.20 370.50,252.65 358.73,261.20 363.23,247.36 351.46,238.81 366.01,238.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.83,224.98 457.33,238.81 471.87,238.81 460.11,247.36 464.60,261.20 452.83,252.65 441.07,261.20 445.56,247.36 433.79,238.81 448.34,238.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.33,259.98 86.83,273.81 101.37,273.81 89.61,282.36 94.10,296.20 82.33,287.65 70.57,296.20 75.06,282.36 63.29,273.81 77.84,273.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.67,259.98 169.16,273.81 183.71,273.81 171.94,282.36 176.43,296.20 164.67,287.65 152.90,296.20 157.39,282.36 145.63,273.81 160.17,273.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.00,259.98 251.49,273.81 266.04,273.81 254.27,282.36 258.77,296.20 247.00,287.65 235.23,296.20 239.73,282.36 227.96,273.81 242.51,273.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.33,259.98 333.83,273.81 348.37,273.81 336.61,282.36 341.10,296.20 329.33,287.65 317.57,296.20 322.06,282.36 310.29,273.81 324.84,273.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.67,259.98 416.16,273.81 430.71,273.81 418.94,282.36 423.43,296.20 411.67,287.65 399.90,296.20 404.39,282.36 392.63,273.81 407.17,273.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.17,294.98 45.66,308.81 60.21,308.81 48.44,317.36 52.93,331.20 41.17,322.65 29.40,331.20 33.89,317.36 22.13,308.81 36.67,308.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.50,294.98 127.99,308.81 142.54,308.81 130.77,317.36 135.27,331.20 123.50,322.65 111.73,331.20 116.23,317.36 104.46,308.81 119.01,308.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.83,294.98 210.33,308.81 224.87,308.81 213.11,317.36 217.60,331.20 205.83,322.65 194.07,331.20 198.56,317.36 186.79,308.81 201.34,308.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.17,294.98 292.66,308.81 307.21,308.81 295.44,317.36 299.93,331.20 288.17,322.65 276.40,331.20 280.89,317.36 269.13,308.81 283.67,308.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.50,294.98 374.99,308.81 389.54,308.81 377.77,317.36 382.27,331.20 370.50,322.65 358.73,331.20 363.23,317.36 351.46,308.81 366.01,308.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.83,294.98 457.33,308.81 471.87,308.81 460.11,317.36 464.60,331.20 452.83,322.65 441.07,331.20 445.56,317.36 433.79,308.81 448.34,308.81"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/en_flag.97884b711d18c40130079ba60d47b6d7.svg";